import type {
    DashboardApi,
    DataSourceDefinition,
} from '@splunk/dashboard-types';

export interface ResolvedSearchProps {
    dataSourceId: string;
    dataSourceDef: DataSourceDefinition;
    dashboardApi: DashboardApi;
}

export const resolvedSearch = ({
    dataSourceId,
    dataSourceDef,
    dashboardApi,
}: ResolvedSearchProps) => {
    const { type, options } = dataSourceDef;
    if (!options) {
        return null;
    }
    if (type === 'ds.chain') {
        return {
            ...dataSourceDef,
            options: {
                ...options,
                ...dashboardApi.getCompleteSearchQueryAndParameters(
                    dataSourceId
                ),
            },
        };
    }
    return dataSourceDef;
};
